module.exports = "/_next/static/images/PlanFeatures@2x-485c8c71062b9b0d34503eaf38adf8c5.webp";